import React from 'react';
import SEOHead from '../components/SEOHead';
import Hero from '../components/Hero';
import Services from '../components/Services';
import Showcase from '../components/Showcase';
import About from '../components/About';
import Projects from '../components/Projects';
import Contact from '../components/Contact';

const HomePage = () => {
  const siteUrl = "https://www.set-g.com";
  
  const homeStructuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "@id": `${siteUrl}/#webpage`,
    "url": siteUrl,
    "name": "SET-G | Expert Télécoms & IT en Côte d'Ivoire | Audit QoS, Ingénierie Radio",
    "description": "SET-G - Leader en audit QoS, ingénierie radio et solutions IT en Côte d'Ivoire. +255 localités auditées pour ARTCI, ORANGE CI, SIR.",
    "isPartOf": {"@id": `${siteUrl}/#website`},
    "about": {"@id": `${siteUrl}/#organization`},
    "primaryImageOfPage": {
      "@type": "ImageObject",
      "url": "https://customer-assets.emergentagent.com/job_bbf88a63-9ea0-4f33-b8a4-13e4c3715502/artifacts/bwb2vqa2_SET-G_Slide1_Final.png"
    },
    "breadcrumb": {
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Accueil",
          "item": siteUrl
        }
      ]
    }
  };

  return (
    <>
      <SEOHead
        title="Expert Télécoms & IT en Côte d'Ivoire | Audit QoS, Ingénierie Radio"
        description="SET-G (Strategies Engineerings and Technologies Global) - Leader en audit QoS et ingénierie radio en Côte d'Ivoire. +255 localités auditées, +14 projets pour ARTCI, ORANGE CI, SIR. ☎ +225 27 22 34 98 15"
        keywords="SET-G, audit QoS Côte d'Ivoire, ingénierie radio Abidjan, expert télécommunications, ARTCI, réseaux mobiles 2G 3G 4G, benchmarking QoS, audit qualité de service, infrastructure IT Afrique"
        ogType="website"
        structuredData={homeStructuredData}
      />
      
      <main>
        <Hero />
        <Services />
        <Showcase />
        <About />
        <Projects />
        <Contact />
      </main>
    </>
  );
};

export default HomePage;